import React, { Component } from 'react';
import { connect } from 'react-redux';
import {ONLINESTATUS} from '../../../utils/questionManageType'

import axios from 'axios'
import API  from '../../../API/api';
import {Breadcrumb,  Button, Input, Tag, Row, Col, Icon ,message,Modal,Upload,Spin,Tree,Popconfirm,notification,Tooltip,Radio} from 'antd';
import {PropTypes} from 'prop-types';
import SectionKnowRelevance  from './SectionKnowRelevance'
import SectionWordRelevance  from './SectionWordRelevance'
import ENSectionWordRelevance  from './ENSectionWordRelevance'
import AddAreaDialog  from './addArea'

import $ from '$'
import './style.css'
import Edition  from './Editions/view'
import Book  from './Books/view'
import Assist  from './Assist/view'
import * as action from './action'

import {
	searchAssistAPI,getIssueTreeAPI,getKnowledgeKnowTreeAPI,
	getSectionListAPI,editSectionAPI,
	getAreaTreeAPI
} from '@/API'

const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const RadioGroup = Radio.Group;

class DailyError extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        sectionList:[],
        issueTree:[],
        knowTree:[],
        areaTree:[],
        expandedKeys:[],
        search_id:'',
        search_name:'',//搜索章节名称
        name:'',
        assistModal:false,//名称搜多教辅
        assistList:[],
        selectAssistIndex:0,
        treeNode:[],
        showAreaDialog:false
    }
	searchFlag=false//标记使用搜索框
    //上传知识点关系
    // sectionProps = this.createUploadConfig(API.FRAMEEWORK_SECTION_IMPORT,{assist_id:this.props.assistCurrent})
    // assistKnowProps = this.createUploadConfig(API.FRAMEEWORK_KNOWLEDGE_KNOW_IMPORT,{assist_id:this.props.assistCurrent})
    sectionProps = null;
    assistKnowProps = null;


    componentDidMount(){
        this.init();
    }
    shouldComponentUpdate(nextProps,nextState){
        if(nextProps.assistCurrent!==this.props.assistCurrent){
            this.getSectionList(nextProps.assistCurrent);
            console.log('next',nextProps.assistCurrent,this.props.assistCurrent)
            this.sectionProps = this.createUploadConfig(API.FRAMEEWORK_SECTION_IMPORT,{assist_id:nextProps.assistCurrent})
            this.assistKnowProps = this.createUploadConfig(API.FRAMEEWORK_KNOWLEDGE_KNOW_IMPORT,{assist_id:nextProps.assistCurrent})

        }
        return true
    }  

    init = async ()=>{
        this.props.getFilterList()
        this.getTreeData()
        this.props.assistCurrent>0?this.getSectionList():null

    }
    getTreeData=()=>{
    		getIssueTreeAPI().then((res)=>{
    			 this.setState({issueTree:res.data.list})
    		})
    		getKnowledgeKnowTreeAPI().then((res)=>{
    			 this.setState({knowTree:res.data.list})
    		}) 
    		getAreaTreeAPI().then((res)=>{
    			 this.setState({areaTree:res.data.list})
    		}) 
	 }
   
    handleSearchChange = (e,key) => {
        const { value } = e.target;
        this.setState({[key]: value});
    }

    //章节搜索
	searchSection=(type)=>{
		let params={
			name:this.state.search_name,
			section_id:this.state.search_id
		}
		//todo  定义方法，请求成功后 设定三个选项。更新section
		searchAssistAPI(type,params).then(res=>{
			let data=res.data
			if(type=='search_name'&&data.length>1){
				this.setState({
					assistModal:true,
					assistList:data
				})
			}else{
				data=data[0]||data
				let edition_id=data.edition.edition_id,
					book_id=data.book.book_id,
					assist_id=data.assist.assist_id
				let 	expandedKeys=data.section.map(v=>{
					return v.section_id
				})
				this.props.setPropsEditionCurrent(edition_id)
				this.props.setHandleEdition(edition_id)
				this.props.setHandleBook(book_id)
				this.props.setHandleAssist(assist_id)
				this.setState({expandedKeys:	expandedKeys})
				
			}
			this.searchFlag=true
			
			
		}).catch(e=>{
		})
	}
	//名称搜索多教辅时，弹框选择
	renderAssistModal(){
		 let {assistList,selectAssistIndex}=this.state
		
		 const radioStyle = {
		      display: 'block',
		      height: '30px',
		      lineHeight: '30px',
		  };
		 let radioOptions=assistList.map((item,index)=>{
		      return (
		  		<Radio key={index} style={radioStyle}  value={index}>{item.edition.name}{item.book.name}{item.assist.name}</Radio>
		      );
		});
		return (
			 <Modal
		          title="请选择教辅"
		          visible={this.state.assistModal}
		          onOk={this.handleSetAssist}
		          onCancel={this.handleCancel}
		        >
			 	 <RadioGroup onChange={this.handleSelectAssist} value={selectAssistIndex}>
			        {radioOptions}
			      </RadioGroup>
		     </Modal>
		)
		
	}
	handleCancel=()=>{
		this.setState({assistModal:false})
	}
    handleSelectAssist=(e)=>{
    		this.setState({selectAssistIndex:e.target.value})
    }
    handleSetAssist=()=>{
    		let {selectAssistIndex,assistList}=this.state
    		let selectAssist=assistList[selectAssistIndex]

    		let edition_id=selectAssist.edition.edition_id,
			book_id=selectAssist.book.book_id,
			assist_id=selectAssist.assist.assist_id

		let 	expandedKeys=[]
		selectAssist.section.forEach(v=>{
					v.forEach(n=>{
						expandedKeys.push(n.section_id)
					})
			})
		this.props.setPropsEditionCurrent(edition_id)
		this.props.setHandleEdition(edition_id)
		this.props.setHandleBook(book_id)
		this.props.setHandleAssist(assist_id)
		this.setState({expandedKeys:	expandedKeys})
		this.setState({assistModal:false})
		
    }

    //章节列表
    getSectionList=(assistCurrent)=>{


        getSectionListAPI({assist_id:assistCurrent||this.props.assistCurrent}).then((res)=>{
        		let data=res.data
        		let expandedKeys = this.state.expandedKeys
        		//非搜索时默认展开两层
        		if(!this.searchFlag){
        			expandedKeys =[]
                data.list.forEach((v)=>{
                    expandedKeys.push(v.section_id)
                    v.list&&v.list.forEach((n)=>{
                        expandedKeys.push(n.section_id)
                    })
                })
                expandedKeys = [...new Set(expandedKeys)]	                
        		}
        		
        		let treeNode=this.loop(data.list)
        		this.setState({sectionList:data.list,expandedKeys,treeNode})
        		this.searchFlag=false

        })

    }
	createDownload(params){
		let {url,valList}=params
		
		let form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', url);
        let inputTemp = $('<input>');
        inputTemp.attr('type', 'hidden');
        valList.forEach(v=>{
        		inputTemp.attr(v.key, v.value);
        })
        $('body').append(form);  //将表单放置在web中
        form.append(inputTemp);   //将查询参数控件提交到表单上
        form.submit();
	}
    //下载模板
    downloadAssist=()=>{
		let params={
			url:API.FRAMEEWORK_SECTION_DOWNLOAD_LIST,
			valList:[{
				key:'name',
				value:'assist_id'
			},{
				key:'value',
				value:this.props.assistCurrent
			}]
		}
		this.createDownload(params)

    }
    downloadAssistKnow=()=>{
		let params={
			url:API.FRAMEEWORK_SECTION_KNOW_DOWNLOAD,
			valList:[{
				key:'name',
				value:'assist_id'
			},{
				key:'value',
				value:this.props.assistCurrent
			}]
		}
		this.createDownload(params)
    }

    downloadSectionFormat=()=>{
		let params={
			url:API.FRAMEEWORK_SECTION_DOWNLOAD_FORMAT,
			valList:[]
		}
		this.createDownload(params)
    }
	downloadAssistKnowFormat=()=>{
		let params={
			url:API.FRAMEEWORK_KNOWLEDGE_KNOW_IMPORT_FORMAT,
			valList:[]
		}
		this.createDownload(params)
    }
	createUploadConfig(url,data){
		return {
			name: 'file',
	        action: url,
	        data,
	        beforeUpload(file) {
	            let xls = false
	            if(file.type === ''){if(/.xls/.exec(file.name)){xls = true}}
	            const notExcel = !(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'||file.type === 'application/vnd.ms-excel'||xls);
	            if(notExcel){
	                message.error('上传文件格式不是Excel')
	                return false
	            }
	        },
	        onChange(info) {
	            if (info.file.status === 'done') {
	                if(info.file.response.code === 0){
	                		message.success(`${info.file.name} 上传成功`);
	                }else {
	                		message.success(`${info.file.response.message}`);
	                }
	            } else if (info.file.status === 'error') {
	                message.error(`${info.file.name} 上传失败`);
	            }
	        },
		}
	}


    addRootSection=()=>{//添加根结点章节
        this.setState({visibleSection:true,editSection:{},name:'',mark:'',})
    }
    openSectionAdd = (section)=>{//章节添加
        this.setState({visibleSection:true,editSection:section,name:'',mark:''})
    }
    openSectionEdit = (section)=>{//章节修改
        this.setState({visibleSectionEdit:true,editSection:section,name:section.name,mark:section.mark})
    }
    editSection = ()=>{//章节修改
        if(this.state.name===''){
            return message.error('请填写章节名')
        }
        let {name,mark,editSection} = this.state
        let params = {
            name,
            mark,
            section_id:editSection.section_id,
        }
        editSectionAPI(params).then((res)=>{
        		message.success('编辑成功')
            this.setState({visibleSectionEdit:false})
            this.getSectionList()
        })

    }
    addSection = ()=>{//章节添加
        let state = this.state
        if(this.state.name===''){
            return message.error('请填写章节名')
        }
        let data = {
            assist_id:this.props.assistCurrent||(this.props.assistList[0]&&this.props.assistList[0].assist_id),
            name:state.name,
            mark:state.mark,
            parent_id:state.editSection.section_id||0,
        }
        return axios.post(API.FRAMEEWORK_SECTION_ADD, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.setState({visibleSection:false})

                let expandedKeys = [...this.state.expandedKeys]
                expandedKeys.push(''+state.editSection.section_id)
                expandedKeys.push(''+res.data)

                this.setState({expandedKeys})

                setTimeout(()=>{this.getSectionList()},0)
            }else{
                message.error(res.message)
                this.setState({visibleSection:false})

            }
        },()=>{message.error("网络错误！")})
    }
    onlineSection = (id)=>{//章节上线
        let data = {
            section_id:id,
        }
        axios.post(API.FRAMEEWORK_SECTION_ONLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('上线成功，次日生效')
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    offlineSection = (id)=>{//章节下线
        let data = {
            section_id:id,
        }
        axios.post(API.FRAMEEWORK_SECTION_OFFLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('下线成功，次日生效')
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    delSection = (id)=>{//章节删除
        let data = {
            section_id:id,
        }
        axios.post(API.FRAMEEWORK_SECTION_DEL, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    onlineTestAssist= (id)=>{//上测试
        let data ={
            section_id:id,
            preview_type:this.state.preview_type,
        }
        axios.post(API.SECTION_TEST, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

	//关掉多层（因设置expandedKeys后无法自动关掉多层）
    onTreeExpand=(expandedKeys,obj)=>{
        let expandedKeysSet = new Set(expandedKeys)
        if(!obj.expanded){
            const loop = (data, key, callback) => {
                data.forEach((item, index, arr) => {
                    if (item.section_id === key) {
                        return callback(item, index, arr);
                    }
                    if (item.list) {
                        return loop(item.list, key, callback);
                    }
                });
            };
            //所有节点执行cb的loop
            const loopAll = (data, callback) => {
                data.forEach((item, index, arr) => {
                    callback(item, index, arr);
                    if(item.list) {
                        return loopAll(item.list, callback);
                    }
                });
            };
            loop(this.state.sectionList, obj.node.props.eventKey, (item, index, arr) => {
                //目标节点下的所有节点从expandedKeys中移除
                item.list&&loopAll(item.list,(item1)=>{
                    expandedKeysSet.delete(item1.id)
                })
            });
        }
        this.setState({expandedKeys:[...expandedKeysSet],autoExpandParent: false,})

    }
    onDrop = (info) => {
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        const dropPos = info.node.props.pos.split('-');
        let move_type = 1//1前 2后 3中间
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
        // const dragNodesKeys = info.dragNodesKeys;


        const loop = (data, key, callback) => {
            data.forEach((item, index, arr) => {
                if (item.section_id === key) {
                    return callback(item, index, arr);
                }
                if (item.list) {
                    return loop(item.list, key, callback);
                }
            });
        };
        const data = [...this.state.sectionList];
        let dragObj;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });
        if (info.dropToGap) {
            let ar;
            let i;
            loop(data, dropKey, (item, index, arr) => {

                ar = arr;
                i = index;
            });
            if (dropPosition === -1) {
                ar.splice(i, 0, dragObj);
                move_type = 1

            } else {
                ar.splice(i + 1, 0, dragObj);
                move_type = 2

            }
        } else {
            move_type = 3
            loop(data, dropKey, (item) => {
                item.list = item.list || [];
                // where to insert 示例添加到尾部，可以是随意位置
                item.list.push(dragObj);
            });
        }
        this.setState({
            sectionList: data,
        });

        //move 知识点移动请求
        let postBody = {
            section_id:dragKey,
            move_type:move_type,
            target_section:dropKey,
        }
        axios.post(API.FRAMEEWORK_SECTION_MOVE, postBody).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getSectionList()
            }else{
                message.error(res.message)
                this.getSectionList()
            }
        },()=>{message.error("网络错误！")})

    }
    removeSectionKnow=(section_id,know_id)=>{//删除知识点关联
        let data = {
            section_id,
            know_id
        }
        axios.post(API.FRAMEEWORK_SECTION_KNOW_DEL, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //删除关联地域
    removeSectionArea=(section_id,city_id)=>{
        let data = {
            section_id,
            city_id
        }
        axios.post(API.FRAMEEWORK_SECTION_AREA_DELETE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('删除成功')
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    removeSectionCateitem=(section_id,cateitem_id)=>{//删除知识点关联
        let data = {
            section_id,
            cateitem_id
        }
        axios.post(API.FRAMEEWORK_SECTION_KNOW_DEL_CATEITEM, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    addRelevance=(know_id)=>{//增加知识点关联
        if(!know_id.length){return message.error('未选择知识点或考点')}
        let data = {
            section_id:this.state.addRelevanceId,
            know_id:know_id,
        }
        axios.post(API.FRAMEEWORK_SECTION_KNOW_ADD, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getSectionList()
                this.setState({visibleRelevance:false})
            }else{
                const args = {
                    message: '添加错误',
                    description: res.message,
                    duration: 0,
                };
                notification.open(args);

            }
        },()=>{message.error("网络错误！")})
    }
    
    addRelevanceCateitem=(arr)=>{//增加知识点关联
        arr.forEach(d=>{d.id = d.group})
        if(arr.length){
            let data = {}
            data.cateitem_list = arr
            if(data['cateitem_list']){
                for(let i=0;i<data['cateitem_list'].length;i++){
                    if(data['cateitem_list'][i].list.length>10){
                        return message.error(`${data['cateitem_list'][i].group}数量超过限制`)
                    }
                }
            }
            data.section_id = this.state.addRelevanceId
            axios.post(API.FRAMEEWORK_SECTION_ADD_RELATE_WORD_CHECK, data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    let addWordPre = []
                    let count = 0
                    res.data.map(d=>
                        (d.list.map(item=>
                            count++
                        ))
                    )
                    addWordPre = res.data
                    this.setState({visibleRelevanceCateitem:false,addWord:arr,addWordPre})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }else{
            message.error('未添加字词')
        }

    }
    addWord=()=>{
        let data ={
            cateitem_list:this.state.addWord,
            section_id:this.state.addRelevanceId}

        axios.post(API.FRAMEEWORK_SECTION_ADD_RELATE_WORD,data).then((res)=>{//题盒子
            res = res.data
            if (res.code === 0) {
                message.success('保存成功');
                this.setState({addWord:false})
                this.getSectionList()
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    changeMainType=()=>{//更改主知识点
        let section_id=this.state.changeMainSection_id;
        let know_id=this.state.changeMainKnow_id;
        let mainType=this.state.changeMainMain_type;
        if(mainType>0){
            mainType=0
        }else{
            mainType=1
        }
        let data = {
            section_id,
            know_id,
            main_type:mainType
        }
        axios.post(API.FRAMEEWORK_CHANGE_MAIN_TYPE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.setState({changeMainTypeModal:false})
                this.getSectionList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
	handleAddArea(e,item){
		e.stopPropagation();
		this.setState({showAreaDialog:true,addRelevanceId:item.section_id})
	}
	addArea=(city_id)=>{
        if(!city_id){return message.error('未选择地区')}
        let data = {
            section_id:this.state.addRelevanceId,
            city_id,
        }
        axios.post(API.FRAMEEWORK_SECTION_AREA_ADD, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('添加地域成功')
                this.getSectionList()
                this.setState({showAreaDialog:false})
            }else{
                const args = {
                    message: '添加错误',
                    description: res.message,
                    duration: 0,
                };
                notification.open(args);

            }
        },()=>{message.error("网络错误！")})
    }
    //树结构的loop方法
    loop = (data,nextState) => {
        return data.map((item,index) => {
            return <TreeNode key={item.section_id}  title={
                <span key={item.section_id} style={{fontSize:12}}>{item.know_type=='1'?<Tag color="#2db7f5" style={{marginRight:3}}>考点</Tag>:''}{item.name}({item.section_id})
                                            <span  style={{fontSize:14,color:'#000',marginLeft:5,fontWeight:'600'}}>
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.addSection>0&&
                                                    <Tooltip title={'添加'} mouseEnterDelay={1}>
                                                        <Icon type="plus"  style={{marginLeft:5}} onClick={(e)=>{e.stopPropagation();this.openSectionAdd(item)}}/>
                                                    </Tooltip>
                                                }

                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.editSection>0&&
                                                    <Tooltip title={'编辑'} mouseEnterDelay={1}>
                                                        <Icon type="edit"  style={{marginLeft:5}} onClick={(e)=>{e.stopPropagation();this.openSectionEdit(item)}}/>
                                                    </Tooltip>

                                                }

                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.online>0&&
                                                    <Popconfirm title="确认上线吗？" onConfirm={(e) => {e.stopPropagation();this.onlineSection(item.section_id)}} okText="确认" cancelText="取消">
                                                        <Tooltip title={'上线'} mouseEnterDelay={1}>
                                                            <Icon type="to-top"  style={{marginLeft:5}}/>
                                                        </Tooltip>

                                                    </Popconfirm>
                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.offline>0&&
                                                    <Popconfirm title="确认下线吗？" onConfirm={(e) => {e.stopPropagation();this.offlineSection(item.section_id)}} okText="确认" cancelText="取消">
                                                        <Tooltip title={'下线'} mouseEnterDelay={1}>
                                                            <Icon type="arrow-down" style={{marginLeft:5}}/>
                                                        </Tooltip>

                                                    </Popconfirm>
                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.delSection>0&&
                                                    <Popconfirm title="确认删除吗？" onConfirm={(e) => {e.stopPropagation();this.delSection(item.section_id)}} okText="确认" cancelText="取消">
                                                        <Tooltip title={'删除'} mouseEnterDelay={1}>
                                                            <Icon type="delete"  style={{marginLeft:5}}/>
                                                        </Tooltip>

                                                    </Popconfirm>
                                                }
                                                {
                                                    this.props.user.role_assist && this.props.user.role_assist.onlineTest &&
                                                    <Tooltip title={'上测试'} mouseEnterDelay={1}>
                                                        <Icon type="to-top"  style={{marginLeft:5,color:'rgb(0, 255, 0)'}}
                                                                onClick={()=>{this.setState({preview_type:'qa',visibleOnTest:true,Modal_assist_id:item.section_id})}}
                                                                />
                                                    </Tooltip>


                                                }

                                                {
                                                    item.online_status=='2'?
                                                        <Tag color="#87d068" style={{marginLeft:5}}>{ONLINESTATUS[item.online_status]}</Tag>
                                                        :
                                                        <Tag color="#f50" style={{marginLeft:5}}>{ONLINESTATUS[item.online_status]}</Tag>
                                                }
                                            </span>
                                            <span   style={{maxWidth: '600px',display: 'inline-block',verticalAlign: 'top',whiteSpace: 'normal'}}>
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.addSectionknow>0&&
                                                    <Tooltip title={'添加关联'} mouseEnterDelay={1}>
                                                        <Button size={'small'} onClick={(e)=>{e.stopPropagation();this.setState({visibleRelevance:true,addRelevanceId:item.section_id})}}>
                                                            +知识
                                                        </Button>
                                                    </Tooltip>
                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.addSectionknow>0 && this.props.assist && this.props.assist.type=='134'&&
                                                    <Tooltip title={'添加地域'} mouseEnterDelay={1}>
                                                        <Button size={'small'} onClick={(e)=>this.handleAddArea(e,item)}>
                                                            +地域
                                                        </Button>
                                                    </Tooltip>
                                                }

                                                {
                                                    (this.props.subject=='1'||this.props.subject=='2')&&
                                                    this.props.user.role_assist&&this.props.user.role_assist.addSectionCateitem>0&&
                                                    <Tooltip title={'添加关联'} mouseEnterDelay={1}>
                                                        <Button size={'small'} onClick={(e)=>{e.stopPropagation();this.setState({visibleRelevanceCateitem:true,addRelevanceId:item.section_id})}}>
                                                            +字词
                                                        </Button>
                                                    </Tooltip>
                                                }
                                                {!!item.relate_know.length&&<span style={{display:'inline-block',marginLeft:'10px'}}>关联知识:</span>}
                                                {
                                                    item.relate_know&&item.relate_know.map((val)=>
                                                        <Tag key={val.know_id+item.section_id+Math.random()} style={{display:'inline-block',margin:1.5}}  color="#2db7f5" >
                                                            {
                                                                <span style={{margin:'0 5px'}} onClick={()=>{this.setState({changeMainSection_id:item.section_id,changeMainKnow_id:val.know_id,changeMainMain_type:val.main_type,changeMainTypeModal:true}) }}>
                                                                    {
                                                                        val.main_type>0?
                                                                            <Icon type="star" />
                                                                            :
                                                                            <Icon type="star-o" />
                                                                    }
                                                                </span>

                                                            }

                                                            {val.name} (<span style={{color:'#9ef'}}>{val.know_id}</span>)
                                                            {
                                                                this.props.user.role_assist&&this.props.user.role_assist.delSectionCateitem>0&&
                                                                <Popconfirm title="确认删除吗？" onConfirm={(e)=>{e.stopPropagation();this.removeSectionKnow(item.section_id,val.know_id)}} okText="确认" cancelText="取消">
                                                                    <Tooltip title={'删除'} mouseEnterDelay={1}>
                                                                        <Icon type="close"/>
                                                                    </Tooltip>
                                                                </Popconfirm>
                                                            }
                                                        </Tag>
                                                    )
                                                }
                                                {!!item.relate_city.length&&<span style={{display:'inline-block',marginLeft:'10px'}}>关联地区:</span>}
                                                {
                                                    item.relate_city&&item.relate_city.map((val)=>
                                                        <Tag key={val.city_id+item.section_id+Math.random()} style={{display:'inline-block',margin:1.5}}  color="#2db7f5" >
                                                            {val.city_name}
                                                            {
                                                                this.props.user.role_assist&&this.props.user.role_assist.delSectionCateitem>0&&
                                                                <Popconfirm title="确认删除吗？" onConfirm={(e)=>{e.stopPropagation();this.removeSectionArea(item.section_id,val.city_id)}} okText="确认" cancelText="取消">
                                                                    <Tooltip title={'删除'} mouseEnterDelay={1}>
                                                                        <Icon type="close"/>
                                                                    </Tooltip>
                                                                </Popconfirm>
                                                            }
                                                        </Tag>
                                                    )
                                                }


                                                {
                                                    (this.props.subject=='1'||this.props.subject=='2')&&
                                                    item.cateitem&&item.cateitem.length>0&&item.cateitem.map((val,i)=>
                                                        <div key={i}>
                                                            <span>{val.group}:</span>
                                                            {val.cateitem.map(d=>
                                                                <Tag key={d.cateitem_id} style={{display:'inline-block',margin:1.5}}  color="#b72df5" >
                                                                    {d.cateitem}&nbsp;&nbsp;&nbsp;
                                                                    {
                                                                        this.props.user.role_assist&&this.props.user.role_assist.delSectionknow>0&&
                                                                        <Popconfirm title="确认删除吗？" onConfirm={(e)=>{e.stopPropagation();this.removeSectionCateitem(item.section_id,d.cateitem_id)}} okText="确认" cancelText="取消">
                                                                            <Tooltip title={'删除'} mouseEnterDelay={1}>
                                                                                <Icon type="close"/>
                                                                            </Tooltip>
                                                                        </Popconfirm>
                                                                    }
                                                                </Tag>
                                                            )}
                                                        </div>

                                                    )
                                                }
                                            </span>

                                        </span>}
                              key={item.section_id}
            >
                {
                    item.list && item.list.length&&
                    this.loop(item.list,nextState)
                }
            </TreeNode>;
        });
    }

    render() {
        return (
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>知识点&教辅管理</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:19}}>
                        <span>教辅管理</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                {this.renderAssistModal()}
                <Row style={{marginTop:15}}>
                    <div>
                    		 <Search
                             placeholder = "请输入章节ID"
                             style = {{ width: 150,margin:20 }}
                             onSearch= {()=>this.searchSection('search_id') }
                             size="large"
                             onChange = {(e)=>this.handleSearchChange(e,'search_id')}
                         />
                         <Search
                             placeholder = "请输入章节名称"
                             style = {{ width: 150,margin:20}}
                             onSearch= {()=>this.searchSection('search_name') }
                             size="large"
                             onChange = {(e)=>this.handleSearchChange(e,'search_name')}
                         />
                        <Edition/>
                        <Book/>
                        <Assist/>
                    </div>

                    <div>
                        <Row style={{borderTop:'1px solid #aaa',marginBottom:'20px'}}></Row>
                        <Row  style={{marginBottom:'20px'}}>
                            {
                                this.props.user.role_assist&&this.props.user.role_assist.addSection&&
                                <Button onClick={()=>{this.addRootSection()}} style={{marginRight:20,marginBottom:10,fontWeight:'600'}}>添加一级章节 <Icon type={'plus'}/></Button>

                            }
                            {
                                this.props.user.role_assist&&this.props.user.role_assist.downloadSection&&
                                <Button style={{marginRight:20,marginBottom:10,fontWeight:'600'}}  onClick={()=>{this.downloadAssist()}}>下载章节表 </Button>
                            }

                            {
                                this.props.user.role_assist&&this.props.user.role_assist.donwloadSectionknow&&
                                <Button style={{marginRight:20,marginBottom:10,fontWeight:'600'}} onClick={()=>{this.downloadAssistKnow()}}>下载关联表 </Button>
                            }



                            <Button style={{marginBottom:10,fontWeight:'600'}} onClick={()=>{this.downloadSectionFormat()}}>章节导入模版下载 </Button>

                            {
                                this.props.user.role_assist&&this.props.user.role_assist.importSection&&
                                <Upload
                                    {...this.sectionProps}
                                    showUploadList={false}
                                >
                                    <Button>
                                        <Icon type="upload" /> 章节导入
                                    </Button>
                                </Upload>
                            }

                            <Button style={{marginLeft:20,marginBottom:10,fontWeight:'600'}} onClick={()=>{this.downloadAssistKnowFormat()}}>知识点关系导入模版下载</Button>
                            {
                                this.props.user.role_assist&&this.props.user.role_assist.importSectionknow&&
                                <Upload
                                    {...this.assistKnowProps}
                                    showUploadList={false}
                                >
                                    <Button>
                                        <Icon type="upload" /> 知识点关系导入
                                    </Button>
                                </Upload>
                            }

                        </Row>
                        <Row>
                            <Spin spinning = {false}>
                                <div className={'knowledgeTree'}>
                                    <Tree
                                        showLine
                                        expandedKeys={this.state.expandedKeys}
                                        onSelect={this.onSelect}
                                        onExpand={this.onTreeExpand}
                                        showIcon={false}
                                        draggable={!!(this.props.user.role_assist&&this.props.user.role_assist.moveSection)}
                                        onDrop={this.onDrop}
                                        autoExpandParent={this.state.autoExpandParent}
                                    >
                                        {this.state.treeNode.map(d=>d)}
                                    </Tree>
                                </div>
                            </Spin>
                        </Row>
                    </div>

                </Row>

                <Modal
                    width={250}
                    visible={ this.state.changeMainTypeModal }
                    onOk={ this.changeMainType }
                    onCancel={ ()=>{this.setState({changeMainTypeModal:false})} }
                    okText = { '确定' }
                >
                    {
                        this.state.changeMainMain_type>0?
                            <span>
                                  确定取消标记为主知识点？
                                </span>:
                            <span>
                                确定标记为主知识点？
                                </span>
                    }

                </Modal>

                {/*章节 增加的模态框*/}
                <Modal
                    title={'章节修改'}
                    visible={ this.state.visibleSectionEdit }
                    onOk={ this.editSection }
                    onCancel={ ()=>{this.setState({visibleSectionEdit:false})} }
                    okText = { '确定' }
                >
                    <Row className="row" >
                        <Col span={3}>章节名称：</Col>
                        <Col span={21}>
                            <Input placeholder = "输入名称(必填)" value={this.state.name} onChange = { e => this.setState({name:e.target.value}) } />
                        </Col>
                    </Row>

                    <Row className="row"  style={{marginTop:20}}>
                        <Col span={3}>概要</Col>
                        <Col span={21}>
                            <Input placeholder = "输入概要(非必填)" value={this.state.mark} onChange = {  e => this.setState({mark:e.target.value}) } />
                        </Col>
                    </Row>
                </Modal>
                {/*章节 修改的模态框*/}
                <Modal
                    title={'章节添加'}
                    visible={ this.state.visibleSection }
                    onOk={ this.addSection }
                    onCancel={ ()=>{this.setState({visibleSection:false})} }
                    okText = { '添加' }
                >
                    <Row className="row" >
                        <Col span={3}>章节名称：</Col>
                        <Col span={21}>
                            <Input placeholder = "输入名称(必填)" value={this.state.name} onChange = { e => this.setState({name:e.target.value}) } />
                        </Col>
                    </Row>

                    <Row className="row"  style={{marginTop:20}}>
                        <Col span={3}>概要</Col>
                        <Col span={21}>
                            <Input placeholder = "输入概要(非必填)" value={this.state.mark} onChange = {  e => this.setState({mark:e.target.value}) } />
                        </Col>
                    </Row>
                </Modal>

                <SectionKnowRelevance
                    visible={ this.state.visibleRelevance }
                    onOk={ this.addRelevance }
                    onCancel={ ()=>{this.setState({visibleRelevance:false})} }
                    data = {{knowTree:this.state.knowTree,issueTree:this.state.issueTree}}
                />
                <AddAreaDialog
                    visible={ this.state.showAreaDialog}
                    onOk={ this.addArea }
                    onCancel={()=>{this.setState({showAreaDialog:false})} }
                    data = {{areaTree:this.state.areaTree}}
                />
                {
                    this.props.subject=='1'&&
                        <SectionWordRelevance
                            visible={ this.state.visibleRelevanceCateitem }
                            onOk={ this.addRelevanceCateitem }
                            onCancel={ ()=>{this.setState({visibleRelevanceCateitem:false})} }
                            data = {{knowTree:this.state.knowTree,issueTree:this.state.issueTree}}
                            />
                 }
                {
                this.props.subject=='2'&&

                        <ENSectionWordRelevance
                            visible={ this.state.visibleRelevanceCateitem }
                            onOk={ this.addRelevanceCateitem }
                            onCancel={ ()=>{this.setState({visibleRelevanceCateitem:false})} }
                            data = {{knowTree:this.state.knowTree,issueTree:this.state.issueTree}}
                        />
                }


                {
                    (this.props.subject=='1'||this.props.subject=='2')&&
                    this.state.addWord&&
                    <Modal title="提示" visible={this.state.addWord} onOk={this.addWord} onCancel={()=>this.setState({addWord:false})}>
                        <div style={{padding:'10px 20px'}}>
                            {
                                this.state.addWordPre.length>0&&
                                <div>
                                    <span>您所添加的{this.props.subject=='1'?'字/词':'词汇/句型'}：</span>
                                    {this.state.addWordPre.map(d=>
                                        (d.list.map(item=>
                                            <span>{item},</span>
                                        ))
                                    )}
                                    <span>尚未添加至{this.props.subject=='1'?'字/词':'词汇/句型'}库中。</span>
                                </div>
                            }

                            点击确定，将{this.props.subject=='1'?'字/词':'词汇/句型'}添加至{this.props.subject=='1'?'字/词':'词汇/句型'}库，并关联至此章节。
                            点击取消，放弃此次关联操作。
                        </div>
                    </Modal>
                }
                <Modal visible={this.state.visibleOnTest}
                       onOk={(e) => {this.onlineTestAssist(this.state.Modal_assist_id);this.setState({visibleOnTest:false})}}
                       onCancel={() => {
                           this.setState({visibleOnTest: false})}}>
                    <Radio.Group onChange={(e)=>{this.setState({preview_type:e.target.value});}} value={this.state.preview_type}>

                        <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'jiaoyan'}>教研环境</Radio>
                        <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'dev'}>开发环境</Radio>
                        <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'qa'}>QA环境</Radio>

                    </Radio.Group>
                </Modal>
            </div>
        )
    }
}

function mapState(state) {
    const asstst = state.knowledgeAssist.assist;
    return {
        user:state.user,
        editionCurrent:asstst.editionCurrent,
        editionList:asstst.editionList,
        bookCurrent:asstst.bookCurrent,
        bookList:asstst.bookList,
        assistCurrent:asstst.assistCurrent,
        assist:asstst.assist,
        assistList:asstst.assistList,
        subject:state.user.subject

    };
}

function mapDispatch(dispatch) {
    return{
        getFilterList:(val,cb)=>{
            dispatch(action.getFilterList(val,cb))
        },
        setPropsAssistCurrent:(val)=>{
            dispatch(action.setPropsAssistCurrent(val))
        },
        setPropsBookCurrent:(val)=>{
            dispatch(action.setPropsBookCurrent(val))
        },
        setPropsEditionCurrent:(val)=>{
            dispatch(action.setPropsEditionCurrent(val))
        },
        //名称搜索到多教辅时,进行手动赋值课本和教辅
        setHandleEdition:(val)=>{
            dispatch(action.setHandleEdition(val))
        },
        setHandleBook:(val)=>{
            dispatch(action.setHandleBook(val))
        },
        setHandleAssist:(val)=>{
            dispatch(action.setHandleAssist(val))
        },
        
        
    }
}
export default connect(mapState, mapDispatch)(DailyError);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/view.js